<template>
  <div class="news-sort" ref="target">
    <div class="left">
      <i></i>
      <RouterLink target="_blank" to="/news/newslist?firstCate=206">
        执业资格</RouterLink
      >
    </div>
    <div class="right">
      <RouterLink target="_blank" to="/news/newslist?firstCate=206">
        <span>更多</span>
        <el-icon><ArrowRight /></el-icon>
      </RouterLink>
    </div>
  </div>
  <div class="news-tabs">
    <ShTabs v-model="activeName">
      <ShTabsPanel label="临床" name="linchuang">
        <LinChuang
          :noticeList="noticeList"
          :policyList="policyList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="中医" name="zhongyi">
        <ZhongYi
          :noticeList="noticeList"
          :policyList="policyList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="中西医" name="zhongxiyi"
        ><ZhongXiYi
          :noticeList="noticeList"
          :policyList="policyList"
          :bannerList="bannerList"
      /></ShTabsPanel>
      <ShTabsPanel label="口腔" name="kouqiang"
        ><KouQiang
          :noticeList="noticeList"
          :policyList="policyList"
          :bannerList="bannerList"
        />
      </ShTabsPanel>
      <ShTabsPanel label="乡村全科" name="xiangcun"
        ><XiangCun
          :noticeList="noticeList"
          :policyList="policyList"
          :bannerList="bannerList"
      /></ShTabsPanel>
      <ShTabsPanel label="执业护士" name="hushi">
        <Nurse />
      </ShTabsPanel>
      <ShTabsPanel label="执业药师" name="zhiyeyaoshi">
        <ZhiYeYaoShi />
      </ShTabsPanel>
      <ShTabsPanel label="执业兽医" name="shouyi"><ShouYi /></ShTabsPanel>
      <ShTabsPanel label="师承/专长" name="zhuanchang"
        ><ZhuanChang
      /></ShTabsPanel>
    </ShTabs>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useLazyNews, useLazyNewsBanner } from "@/hooks/index";
//import { useStore } from "vuex";
import { findZhiYeNews, findNewsBanner } from "@/api/news";
import LinChuang from "./zhiye/linchuang-news.vue";
import ZhongYi from "./zhiye/zhongyi-news.vue";
import ZhongXiYi from "./zhiye/zhongxiyi-news.vue";
import KouQiang from "./zhiye/kouqiang-news.vue";
import XiangCun from "./zhiye/xiangcun-news.vue";
import Nurse from "./zhiye/nurse-news.vue";
import ZhiYeYaoShi from "./zhiye/zhiyeyaoshi-news.vue";
import ShouYi from "./zhiye/shouyi-news.vue";
import ZhuanChang from "./zhiye/zhuanchang-news.vue";
export default {
  name: "ZhiYeNewsList",
  components: {
    LinChuang,
    ZhongYi,
    ZhongXiYi,
    KouQiang,
    XiangCun,
    Nurse,
    ZhiYeYaoShi,
    ShouYi,
    ZhuanChang,
  },
  setup() {
    //const store = useStore();
    const noticeList = ref([]);
    const policyList = ref([]);
    const target = ref(null);

    //新闻列表数据懒加载
    const { notice, policy } = useLazyNews(target, () =>
      findZhiYeNews({ chID: 206, coID: 206 })
    );

    //新闻页面news数据懒加载
    const { bannerList } = useLazyNewsBanner(target, () =>
      findNewsBanner({ chID: 206, coID: 206 })
    );

    //医师类（临床、中医、中西医、口腔、乡村全科）
    watch(policy, () => {
      //console.log(policy);

      let list = policy.value?.filter((item, index) => {
        return item.chID == 206 && item.coID == 206 && item.clID != 3558;
      });
      if (policyList.value.length <= 10) {
        policyList.value = list;
      } else {
        policyList.value = list.slice(0, 10);
      }
    });
    watch(notice, () => {
      let list = notice.value?.filter((item, index) => {
        return item.chID == 206 && item.coID == 206 && item.clID != 3558;
      });
      if (list.length <= 5) {
        noticeList.value = list;
      } else {
        noticeList.value = list.slice(0, 5);
      }
    });

    //console.log(notice);

    const activeName = ref("linchuang");
    return {
      activeName,
      policyList,
      noticeList,
      target,
      bannerList,
    };
  },
};
</script>

<style lang="less" scoped>
.news-sort {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  background: rgb(244, 244, 244);

  .left {
    i {
      display: inline-block;
      width: 3px;
      height: 20px;
      background: @shColor;
      margin-right: 15px;
    }
    a {
      font-size: 22px;
      &:hover {
        color: @shColor;
      }
    }
  }
  .right {
    margin-right: 10px;
    :hover {
      color: @shColor;
    }
    a {
      display: flex;
      align-items: center;
      color: #999;
    }
  }
}
.news-tabs {
}
</style>
